interface OneTrustOptions {
  scriptUrl: string;
  domainScript: string;
}

class OneTrust {
  public static initialize(options: OneTrustOptions) {
    OneTrust.addCookieLawScript(options);
    OneTrust.addOptanonScript();
  }

  public static notifyPageChange() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const reloadOTBannerFunction = (window as any).reloadOTBanner;

    if (reloadOTBannerFunction) {
      reloadOTBannerFunction();
    }
  }

  private static addCookieLawScript(options: OneTrustOptions) {
    const script = document.createElement("script");
    script.src = options.scriptUrl;
    script.type = "text/javascript";
    script.dataset.domainScript = options.domainScript;
    document.body.appendChild(script);
  }

  private static addOptanonScript() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.text = "function OptanonWrapper() { }";
    document.body.appendChild(script);
  }
}

export default OneTrust;
